<template>
    <div class="heading">
        <div class="heading-title">
            <img height="32" src="data:image/svg+xml,%3Csvg width='544' height='72' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%235E6271' fill-rule='evenodd'%3E%3Cpath d='M135.803 58.2v-7.7h-7.694V27.4h7.694v-7.7H112.72v7.7h7.694v23.1h-7.694v7.7h23.082zm30.776-30.8v-7.7H151.19v7.7h15.388zM151.19 50.5V27.4h-7.694v23.1h7.694zm15.388 7.7v-7.7H151.19v7.7h15.388zm30.776-30.8v-7.7h-15.388v7.7h15.388zm-15.388 23.1V27.4h-7.694v23.1h7.694zm23.082 0V27.4h-7.694v23.1h7.694zm-7.694 7.7v-7.7h-15.388v7.7h15.388zm23.082 0V35.1h7.694v-7.7h-7.694v-7.7h-7.694v38.5h7.694zm23.082 0V19.7h-7.694v15.4h-7.694v7.7h7.694v15.4h7.694zm30.776-7.7v-7.7h-23.082v7.7h23.082zm15.388 7.7V42.8h7.694v-7.7h-7.694v-7.7h7.694v-7.7h-15.388v38.5h7.694zm15.388-23.1v-7.7h-7.694v7.7h7.694zm23.082-7.7v-7.7h-7.694v7.7h7.694zm-7.694 30.8V42.8h7.694v15.4h7.694V27.4h-7.694v7.7h-7.694v-7.7h-7.694v30.8h7.694zm46.164-30.8v-7.7h-15.388v7.7h15.388zm-15.388 23.1V27.4h-7.694v23.1h7.694zm15.388 7.7v-7.7h-15.388v7.7h15.388zm15.388 0V42.8h7.694v-7.7h-7.694V19.7h-7.694v38.5h7.694zM397.4 35.1V19.7h-7.694v15.4h7.694zm0 23.1V42.8h-7.694v15.4h7.694zm30.776-7.7v-7.7h-23.082v7.7h23.082zm15.388 7.7V35.1h7.694v-7.7h-7.694v-7.7h-7.694v38.5h7.694zm30.776 0V19.7h-7.694v7.7h-7.694v7.7h7.694v23.1h7.694zm-15.388-15.4v-7.7h-7.694v7.7h7.694zm38.47-15.4v-7.7h-7.694v7.7h7.694zm-7.694 30.8V42.8h7.694v15.4h7.694V27.4h-7.694v7.7h-7.694v-7.7h-7.694v30.8h7.694zm30.776 0V35.1h7.694v-7.7h-7.694v-7.7h-7.694v38.5h7.694zm23.082 0V19.7h-7.694v15.4h-7.694v7.7h7.694v15.4h7.694z' fill-rule='nonzero'/%3E%3Cpath d='M37.214 0c10.53 0 20.04 4.231 26.81 11.032l2.124-2.067L95 37.053 66.148 65.14l-3.21-3.125C56.254 68.2 47.192 72 37.213 72 16.661 72 0 55.882 0 36S16.661 0 37.214 0zm0 7.164c-16.542 0-29.953 12.99-29.953 29.015s13.41 29.015 29.953 29.015c8.037 0 15.334-3.066 20.713-8.056L37.296 37.053 58.828 16.09c-5.451-5.502-13.12-8.927-21.614-8.927z'/%3E%3C/g%3E%3C/svg%3E" />
            <!-- IconPack Man -->
        </div>
        <!-- <div class="subheading">Check your Icon-Packs {{ version }}</div> -->
        <!-- <span class="subheading"> {{ version }}</span> -->

        <div class="navbar right">
            <button v-show="home" class="buxtton" @click.stop.prevent="loadIconPack">Open Icon Pack...</button>
            <a v-for="(doc,i) in documents" :key="i" href="#" :class="{ active: loaded == doc.doc }" class="xhelp button" @click="loadComponentData(doc.doc)">{{ doc.name }}</a>
            <button v-show="home" class="toolicon console-icon" @click.stop.prevent="toggleConsole">&nbsp;</button>
            <button v-show="home" class="toolicon menu-icon" @click.stop.prevent="toggleSidebar">&nbsp;</button>
        </div>
    </div>
</template>

<script>
// const ipmSVG = "data:image/svg+xml,%3Csvg width='144' height='144' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='1'%3E%3Cpath opacity='0' fill='%2300f' d='M0 0h144v144H0z'/%3E%3Cpath fill='%235e6271' d='M57.42 13c10.364 0 20.168 3.086 28.572 8.978a51.59 51.59 0 018.132 6.961l3.472-3.425 39.734 39.205-39.734 39.206-4.602-4.542a49.887 49.887 0 01-3.08 2.834C80.95 109.792 69.183 114 57.42 114c-13.445 0-26.05-5.33-35.574-14.87C12.322 89.593 7 76.968 7 63.5c0-13.467 5.322-26.092 14.846-35.63C31.37 18.33 43.975 13 57.42 13zm.28 9.82a40.08 40.08 0 00-26.033 9.542C22.417 39.695 16.5 50.919 16.5 63.5c0 20.611 15.882 37.582 36.288 39.763 1.612.215 3.25.335 4.912.356 8.684 0 16.807-2.805 23.81-7.855a40.876 40.876 0 004.17-3.596L57.863 64.719l29.356-28.965C79.801 27.644 69.194 22.82 57.7 22.82zM15.106 134v-2.4h-2.368v-7.2h2.368V122H8v2.4h2.369v7.2H8v2.4h7.106zm9.476-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.369v7.2h2.37zm4.738 2.4v-2.4h-4.738v2.4h4.738zm9.475-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.368v7.2h2.368zm7.107 0v-7.2h-2.369v7.2h2.369zm-2.369 2.4v-2.4h-4.738v2.4h4.738zm7.106 0v-7.2h2.37v-2.4h-2.37V122h-2.368v12h2.368zm7.107 0v-12H45.9v4.8h-2.369v2.4h2.37v4.8h2.368zm6.648-4.644v-2.4h-4.28v2.4h4.28zM59.656 134v-4.8h2.369v-2.4h-2.37v-2.4h2.37V122h-4.738v12h2.369zm4.738-7.2v-2.4h-2.37v2.4h2.37zm7.106-2.4V122h-2.369v2.4H71.5zm-2.369 9.6v-4.8H71.5v4.8h2.369v-9.6H71.5v2.4h-2.369v-2.4h-2.369v9.6h2.37zm14.213-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.368v7.2h2.368zm4.738 2.4v-2.4h-4.738v2.4h4.738zm4.738 0v-4.8h2.369v-2.4h-2.37V122h-2.368v12h2.369zm4.737-7.2V122h-2.368v4.8h2.368zm0 7.2v-4.8h-2.368v4.8h2.368zm6.649-4.644v-2.4h-4.28v2.4h4.28zm4.737 4.644v-7.2h2.37v-2.4h-2.37V122h-2.368v12h2.368zm9.476 0v-12h-2.37v2.4h-2.368v2.4h2.369v7.2h2.369zm-4.743-4.8v-2.4h-2.369v2.4h2.369zm11.85-4.8V122h-2.37v2.4h2.37zm-2.37 9.6v-4.8h2.37v4.8h2.368v-9.6h-2.369v2.4h-2.369v-2.4h-2.369v9.6h2.37zm9.476 0v-7.2h2.368v-2.4h-2.368V122h-2.37v12h2.37zm7.106 0v-12h-2.369v4.8h-2.369v2.4h2.37v4.8H135z' /%3E%3C/g%3E%3C/svg%3E";

export default {
    props: {
        version: {
            type: String,
            default: '1.0.0'
        },
        loaded: {
            type: String,
            default: ''
        },
        home: {
            type: Boolean,
            default: true,
        },
        documents: {
            type: Array,
            default() {
                return []
          }
        }
    },
    data: function () {
        return {
            // home: true, //document.location.pathname.includes('index.html'),
        };
    },
    methods: {
        loadIconPack(e) {
            this.$emit('loadiconpack', e);
        },
        toggleSidebar(e) {
            this.$emit('togglesidebar', e);
        },
        toggleConsole(e) {
            this.$emit('toggleconsole', e);
        },
        loadComponentData(e) {
            console.log("emitting. loadcomponentdata",e);
            this.$emit('loadcomponentdata', e);
        },
    },
};
</script>

<style>
.active {
    background-color: green;
}
.tags:not(tbody .tags),
.heading {
    display: flex;
    flex-flow: wrap;
    margin: 16px 16px;
    background: transparent;
    height: 22px;
    padding-left: 16px;
    padding-right: 16px;
    z-index: 1000;
}
.heading-title {
    font-size: 1.5em;
    font-weight: 600;
    margin-bottom: 8px;
}

.heading-smalltitle {
    font-weight: 600;
}
.subheading {
    font-size: 0.5em;
    font-weight: 300;
}
@media (max-width: 800px) {
    .heading, .tags:not(tbody .tags), .heading {
        height: 64px;
    }
}
</style>
